<div>
  <div class="dialog-header">
    <h4>{{ "changeAddress" | translate }}</h4>
    <span class="close-icon" (click)="close()">
      <i class="fa-regular fa-circle-xmark"></i>
    </span>
  </div>
  <div class="dialog-body">
    <div class="dialog-content">
    <!-- Location Options -->
    <div class="location-options">
      <button class="location-btn" (click)="getCurrentLocation()" [disabled]="isGettingLocation">
        <i class="fa-solid fa-location-crosshairs"></i>
        <span>{{ "currentLocation" | translate }}</span>
      </button>
      <button class="location-btn" (click)="openMapSelection()">
        <i class="fa-solid fa-map-location-dot"></i>
        <span>{{ "locateOnMap" | translate }}</span>
      </button>
    </div>

    <!-- Selected Location Display -->
    <div class="selected-location" *ngIf="selectedLocationAddress" [class.active]="isLocationSelected">
      <div class="location-icon">
        <i class="fa-solid fa-location-dot"></i>
      </div>
      <div class="location-details">
        <p class="location-address">{{ selectedLocationAddress }}</p>
        <p class="location-coords" *ngIf="selectedLatLng">
          {{ selectedLatLng.lat.toFixed(6) }}, {{ selectedLatLng.lng.toFixed(6) }}
        </p>
      </div>
      <div class="selected-badge" *ngIf="isLocationSelected">
        <i class="fa-solid fa-circle-check"></i>
      </div>
    </div>

    <!-- Map Selection Modal -->
    <div class="map-modal" *ngIf="showMapModal">
      <div class="map-modal-content">
        <div class="map-modal-header">
          <h4>{{ "selectLocationOnMap" | translate }}</h4>
          <span class="close-icon" (click)="closeMapModal()">
            <i class="fa-regular fa-circle-xmark"></i>
          </span>
        </div>
        <div class="map-container">
          <div #mapElement class="google-map"></div>
          <div class="map-center-marker">
            <i class="fa-solid fa-location-dot"></i>
          </div>
        </div>
        <div class="map-address-display" *ngIf="mapSelectedAddress">
          <p>{{ mapSelectedAddress }}</p>
        </div>
        <button class="confirm-location-btn" (click)="confirmMapLocation()">
          {{ "confirmLocation" | translate }}
        </button>
      </div>
    </div>

    <p>{{ "chooseDeliveryAddress" | translate }}</p>
      <div class="addresses-scrollable">
    <form [formGroup]="changeAddressForm" class="form-group">
      <div class="delivery-address-option" *ngFor="let address of addresses">
        <input
          type="radio"
          [id]="address._id"
          formControlName="address"
          [value]="address._id"
          (change)="onSavedAddressSelect()" />
        <label [for]="address._id" class="delivery-address-label">
          <div class="delivery-address-content">
            <h4 class="delivery-title">
              {{ getAddressType(+address.addressType) }}
            </h4>
            <p class="delivery-address-detail">
              <b>{{ "address" | translate }}: </b>{{ address.address }}
            </p>
            <p class="delivery-address-detail">
              <b>{{ "email" | translate }}: </b>{{ address.email }}
            </p>
            <p class="delivery-address-detail">
              <b>{{ "phone" | translate }}: </b>{{ address.phoneNo }}
            </p>
          </div>
        </label>
        <!-- <div class="action-icons">
          <i
            class="fa-regular fa-pen-to-square edit-icon"
            (click)="editAddress(address)"></i>
          <i
            class="fa-regular fa-trash-can delete-icon"
            (click)="deleteAddress(address)"></i>
        </div> -->
      </div>
    </form>
      </div>
    </div>
    <div class="dialog-footer">
    <p class="add-new-address-text" (click)="addNewAddress()">
      <i class="fa-regular fa-plus"></i>
      {{ "addNewAddress" | translate }}
    </p>
    <button
      class="submit_btn"
      [disabled]="changeAddressForm.invalid && !isLocationSelected"
      (click)="changeAddress()">
      {{ "changeAddress" | translate }}
    </button>
    </div>
  </div>
</div>
